export default __webpack_public_path__ + "static/media/review3.29bc092d.png";